import api from './index'

class BankTxService {
	getTxes(params) {
		return api.get('/bank-transactions', { params })
	}
}

export default new BankTxService()
